import {BlockMath, InlineMath} from "react-katex";

const LogisticRegressionAbout = () => {
    return (
        <div className="max-w-4xl mx-auto px-4">
            <p className="tw-header">Logistic Regression</p>
            <p className="tw-sub-header">
                Logistic Regression within binary classification</p>
            <hr className="mt-4 mb-4"/>
            <p className="tw-subtitle text-gray-600">
                Linear regression has its uses. Its great at predicting continuous values. However, what happens when
                you try to predict a binary outcome? What you might intuitively think about is creating a threshold. You
                might call it a decision threshold. Where if it were to output a value x, then if that value x is
                greater than value z then you might predict one value, and if its less then you might predict another
                outcome. This is however horribly inaccurate when using linear regression, when your data points begin
                accumulating.
            </p>
            <hr className="mt-4 mb-4"/>
            <p className="tw-subtitle text-gray-600">
                What you however could use is logistic regression. Logistic regression is also a linear model. I find
                that many overcomplicate the introduction to it, might be due to them not fully understanding it, I'm
                not sure. But the way you can look at logistic regression, is as a two-step process. <strong
                className="font-semibold">Step 1</strong> is the
                linear step. Where we will calculate the linear output, the exact same way we did in our Linear
                Regression section. Here is an example:
            </p>
            <BlockMath math="linearFunction_w,_b(\vec{x}) = w_1x_1 + w_2x_2 + w_3x_3 + w_4x_4 + b"/>
            <p className="tw-subtitle text-gray-600">
                <strong className="font-semibold">Step 2</strong> is the logistic step. Where we will calculate the
                logistic
                output. This is where we will use the logistic function. The logistic function is a function that
                takes in a value and outputs a value between 0 and 1. In this page we will be using the Sigmoid function
                as that is the most well known logistic function. However you could also use tanh that maps from -1,1
                instead of 0,1 - the prohibit function, or softmax which we will be using the the multiclass
                classification section.
            </p>
            <hr className="mt-4 mb-4"/>
            <p className="tw-subtitle text-gray-600">
                The sigmoid function is defined as:
            </p>
            <BlockMath math="Sigmoid(x) = \frac{1}{1 + e^{-x}}"/>
            <p className="tw-subtitle text-gray-600">
                Where <InlineMath math="x"/> is the input value. The sigmoid function is a function that takes in a
                value
                and outputs a value between 0 and 1. The output of the sigmoid function will always output a result
                between 0 and 1. I dive deeper into why we use the Sigmoid function, and the maths as to why the output
                can only be between 0 and 1.
            </p>
            <br/>
            <p className="tw-subtitle text-gray-600">
                In our below example we will be using sci-kit learns inbuilt logistic regression model to train our very
                simple classification model. In our gradient descent section we will write our custom cost function and
                gradient descent section, but that is not within the scope of this section.
            </p>
            <br/>
            <p className="tw-subtitle text-gray-600">
                Let us notate an example to clarify the sigmoid function. Let's say our model is to predict whether a
                tumor is malignant or benign, meaning weather it is prone to growing or won't grow any further. We have
                two features to base this guess off of, patient age, and tumor size. </p>

        </div>
    )
}

export default LogisticRegressionAbout;